import { Product } from '../../product/Product'
import { ActionArgs } from '../../action/ActionArgs'
import { Field, Float, InputType } from 'type-graphql'

@InputType()
export class AddToCartArgs extends ActionArgs {
  @Field(() => Product)
  product: Product

  @Field(() => Float)
  quantity: number

  @Field(() => String, { nullable: true })
  orderId?: string

  @Field(() => String, { nullable: true })
  remarks?: string
}
